import { Alert, Text, Button, Stack } from '@mantine/core'
import { TbAlertCircle, TbArrowLeft } from 'react-icons/tb'
import { useNavigate } from '@tanstack/react-router'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

const ErrorState = ({
  title,
  message,
  backButtonText,
  backButtonHref = '/',
  icon = <TbAlertCircle size={16} />,
  color = 'red',
  variant = 'light',
  width = 500,
  showBackButton = true,
  retryAction,
  customAction,
}: {
  title: string
  message: string
  backButtonText?: string
  backButtonHref?: string
  icon?: ReactNode
  color?: string
  variant?: 'light' | 'filled' | 'outline'
  width?: number | string
  showBackButton?: boolean
  retryAction?: ReactNode
  customAction?: React.ReactNode
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation('common')
  const resolvedBackButtonText = backButtonText ?? t('backToDashboard')

  const handleBackClick = () => {
    navigate({ to: backButtonHref })
  }

  return (
    <Stack gap="md">
      <Alert icon={icon} title={title} color={color} variant={variant} w={width}>
        <Text size="sm">{message}</Text>
        {showBackButton && !customAction && (
          <Button
            leftSection={<TbArrowLeft size={16} />}
            variant="light"
            onClick={handleBackClick}
            mt="md"
            color={color}
            size="xs"
          >
            {resolvedBackButtonText}
          </Button>
        )}
        {retryAction}
        {customAction}
      </Alert>
    </Stack>
  )
}

export default ErrorState
